import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Subject } from 'rxjs';
import { VideoPlayerComponent } from 'src/app/dialogs/video-player/video-player.component';
import { DeviceService } from '../deviceService/device.service';
import { DialogService } from '../dialogService/dialog-service';
import { RequestService } from '../requestService/request.service';

@Injectable({
  providedIn: 'root'
})
export class PlayMediaService {
  private dialogRef: MatDialogRef<VideoPlayerComponent>;
  getPlayerStatus = new Subject();
  constructor(public dialog: MatDialog, private requestService: RequestService, private dialogService: DialogService, private deviceService: DeviceService) { }

  /**  Open or update video player dialog
   * @param data: Object - asset details including media info
  */
  openVideoPlayer(data) {
    if (this.dialogRef) {
      this.dialogRef.componentInstance.changeMedia(data);
    } else {
      this.dialogRef = this.dialog.open(VideoPlayerComponent, {
        width: '100vw',
        height: '100vh',
        maxWidth: '100vw',
        maxHeight: '100vh',
        hasBackdrop: false,
        autoFocus: false,
        disableClose: false,
        closeOnNavigation: false,
        panelClass: "video-player-dialog",
        data: data
      });

      this.dialogRef.afterClosed().subscribe(result => {
        this.dialogRef = null;
        if (result) {
          this.getPlayerStatus.next(result);
        }
      });
    }
  }

  /**  Call Play Media API
   * @param details: Object asset details
   * @param episode: Object episode details 
  */
  play(details, episode) {
    if (details) {
      if (details.type == 1) {
        details.currentEpisode = episode ? episode : this.getCurrentEpisode(details);
        this.playMedia(details);
      } else {
        this.playMedia(details);
      }
    }

  }

  /** Call playMedia API
  * @param details: Object asset details
  */
  playMedia(details) {
    if (details.media || (details.currentEpisode && details.currentEpisode.media)) {
      let req = {
        url: "/api/plays/playMedia",
        req: {
          mediaId: details.currentEpisode ? details.currentEpisode.media.id : details.media.id,
          format: this.deviceService.getDeviceAlias().videoFormat,
          device: this.deviceService.getDeviceInfo()
        }
      };
      this.requestService.mainPostRequest(req).then((resp: any) => {
        details.video = resp.data;
        details.videoType = "movie";
        details.videoMimeType = this.deviceService.getDeviceAlias().videoFormat == 1 ? "application/dash+xml" : "application/vnd.apple.mpegurl";
        this.openVideoPlayer(details);
      });
    } else {
      this.showNoMediaDialog();
    }
  }

  /** Play a trailer
   * @param details: Object asset details
   * @param trailer: Object trailer media object
  */
  playTrailer(details, trailer) {
    if (trailer && trailer.id) {
      let req = {
        url: "/api/plays/playMedia",
        req: {
          mediaId: trailer.id,
          format: this.deviceService.getDeviceAlias().videoFormat,
          device: this.deviceService.getDeviceInfo()
        }
      };
      this.requestService.mainPostRequest(req).then((resp: any) => {
        details.video = resp.data;
        details.videoType = "trailer";
        details.videoMimeType = this.deviceService.getDeviceAlias().videoFormat == 1 ? "application/dash+xml" : "application/vnd.apple.mpegurl"
        this.openVideoPlayer(details);
      });
    } else {
      this.showNoMediaDialog();
    }
  }

  /** Find Current Episode
  * @param details: Object 
  * @returns episode: Object
  */
  getCurrentEpisode(details) {
    if (details && details.bookmarkInfo && details.bookmarkInfo.seek >= 0) {
      // Find Current Season
      let currentSeason = details.seasons.find(obj => {
        return obj.seasonNumber == details.bookmarkInfo.seasonNumber
      });
      currentSeason = currentSeason ? currentSeason : details.seasons[0];

      // Find Episode in Season
      let currentEpisode = currentSeason.episodes.find(obj => {
        return obj.episodeNumber == details.bookmarkInfo.episodeNumber
      });
      currentEpisode = currentEpisode ? currentEpisode : currentSeason.episodes[0];

      return currentEpisode
    } else {
      return details.seasons[0].episodes[0];
    }
  }

  /** Open no media dialog  */
  private showNoMediaDialog() {
    this.dialogService.openConfirmDialog({
      title: "gen_error",
      message: "MediaNotFound",
      confirm: "gen_ok"
    }).subscribe(result => { });
  }
}